import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 text-center" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-125">
          🔥 ARSENAL DEL SOLDADOR 24HS
        </h3>
        <p className="mb-2" data-id="element-126">
          El sistema completo para pasar de cero a tu primera venta.
        </p>
        <p className="mb-8 italic" data-id="element-127">
          El oficio que aprendés hoy es la libertad que tenés mañana.
        </p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-128">
          <p className="mb-4" data-id="element-129">
            © 2025 GUÍA DIGITAL 360 — Todos los derechos reservados.
            <br data-id="element-130" />
            Hecho con orgullo en Argentina 🇦🇷
          </p>
          <div className="flex justify-center gap-4" data-id="element-131">
            <a href="#" className="hover:text-white transition-colors" data-id="element-132">
              Privacidad
            </a>
            <span data-id="element-133">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-134">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}